import { render } from "./PostNavigation.vue?vue&type=template&id=5c49271a&scoped=true"
import script from "./PostNavigation.vue?vue&type=script&lang=js"
export * from "./PostNavigation.vue?vue&type=script&lang=js"

import "./PostNavigation.vue?vue&type=style&index=0&id=5c49271a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c49271a"]])

export default __exports__